import { render, staticRenderFns } from "./ImgComponent.vue?vue&type=template&id=77495634"
import script from "./ImgComponent.vue?vue&type=script&lang=js"
export * from "./ImgComponent.vue?vue&type=script&lang=js"
import style0 from "./ImgComponent.vue?vue&type=style&index=0&id=77495634&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports